import request from '@/utils/request'

export function GetSumCount() {
  return request({
    url:`/sys/susdaily/index/top/sumCount`,
    method:'post'
  })
}
export function GetMonth(shopId) {
  return request({
    url:`/sys/susdaily/monthDaliy/${shopId}`,
    method:'get'
  })
}
export function GetWeek(shopId) {
  return request({
    url:`/sys/susdaily/weekDaliy/${shopId}`,
    method:'get'
  })
}











